import { render } from "./ReachBrandSafety.vue?vue&type=template&id=9d661506&scoped=true"
import script from "./ReachBrandSafety.vue?vue&type=script&lang=js"
export * from "./ReachBrandSafety.vue?vue&type=script&lang=js"

import "./ReachBrandSafety.vue?vue&type=style&index=0&id=9d661506&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d661506"]])

export default __exports__